import React from 'react';

import { i18next } from '../i18n';

export class LanguagePicker extends React.Component {
    public render(): React.ReactNode {
        return (
            <div>
                <button onClick={() => LanguagePicker.changeLanguage('es')}>es</button>
                <button onClick={() => LanguagePicker.changeLanguage('en')}>en</button>
            </div>
        );
    }

    private static changeLanguage(lang: string): void {
        void i18next.changeLanguage(lang);
    }
}
